import { Controller } from "@hotwired/stimulus"
import { applyPlatformKeys } from "../helpers/platform_keys"

// Spells the <kbd>s of position_grid/_keys inside it the way the platform does (⌘ ⇧ ⌥ on Apple) —
// the toolbar's Hinzufügen menu; the ⓘ dialog does the same in position-grid-shortcuts.
export default class extends Controller {
  connect() {
    applyPlatformKeys(this.element)
  }
}
